import { ChangeDetectionStrategy, Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { LcsSingleSelectSelectedEvent } from 'src/app/common-components/entity-select/single-select/single-select-base';
import { AccountOption } from 'src/app/pages/account-register/models/account-option.interface';
import { AccountSelectParameterFormModel } from '../models/account-select-parameter.value';
import { ReportParameterConfig } from '../report-parameter-list/report-parameter.config';
import { SelectedAccountService } from './data-to-include/selected-account-service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{ multi: true, provide: NG_VALUE_ACCESSOR, useExisting: SelectedAccountReportParameterComponent }],
    selector: 'ndt-select-account-report-parameter',
    templateUrl: './selected-account-report.parameters.component.html',
    standalone: false
})
export class SelectedAccountReportParameterComponent implements OnDestroy {
   config: ReportParameterConfig;

   @Output() accountSelected = new EventEmitter<AccountOption>();

   set form(form: UntypedFormGroup) {
      this._form = form;

      const formValue: AccountSelectParameterFormModel = this.form.value;
      if (formValue) {
         this.initializeContentFormValue(formValue);

         const updatedValue: AccountSelectParameterFormModel = this.form.value;
         const newAccountOptions = {
            accountId: updatedValue.value?.accountId,
            name: updatedValue.name,
         } as AccountOption;

         this.selectedAccountService.setSelectedAccount(newAccountOptions);
      }
   }

   get form(): UntypedFormGroup {
      return this._form;
   }

   get label() {
      return this.config?.label;
   }

   private _form: UntypedFormGroup;

   destroyed$ = new Subject<void>();

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   onAccountSelected(event: LcsSingleSelectSelectedEvent<AccountOption>) {
      const selectedOption = event.option.value;
      this.accountSelected.emit(selectedOption || undefined);

      this.selectedAccountService.setSelectedAccount(selectedOption || null);
   }

   private initializeContentFormValue(formValue: AccountSelectParameterFormModel): void {
      if (typeof this.form.value.value !== 'object') {
         this.form.setValue({
            ...formValue,
            value: {
               accountId: formValue.value,
               name: formValue.name,
            },
         });
      }
   }

   constructor(private store: Store, private selectedAccountService: SelectedAccountService) {}
}
